import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";

const Terms = loadable(() => import("./Terms"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <Terms {...props} />
  </ErrorBoundary>
);
